import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { AddNotesRequestDto } from "../models/cdi/AddNotesRequestDto";
import { AddUpdateCdiLineDto } from "../models/cdi/addUpdateCdiLineDto";
import { CdiDispositionResponseDto } from "../models/cdi/CdiDispositionResponseDto";
import { CdiInvoiceResolutionRequestDto } from "../models/cdi/CDIInvoiceResolutionRequestDto";
import { CdiInvoiceResolutionResponseDto } from "../models/cdi/CDIInvoiceResolutionResponseDto";
import { CDILinesDto } from "../models/cdi/CDILinesDto";
import { CdiListingDto } from "../models/cdi/CdiListingDto";
import { OcrInvoiceMatchingNotes } from "../models/cdi/CDINotes";
import { CopyCdiLinesRequestDto } from "../models/cdi/copyCdiLinesRequestDto";
import { GetCdiDetailsDto } from "../models/cdi/GetCdiDetailsDto";
import { UpdateCdiLineDto } from "../models/cdi/updateCdiLineDto";
import { GenericResponseDto } from "../models/generic-response.dto";
import { SalesOrderNotes } from "../models/orders/salesOrderNotes";
import { GenericRequestDto } from "../models/generic-request.dto";

@Injectable({
  providedIn: "root",
})
export class CDISummaryService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";
  private cdiInvoiceBaseURL = environment.baseUrl + "/CdiInvoice";
  private d365SynchroniserBaseURL = environment.baseUrl + "/D365Synchroniser";
  constructor(private _http: HttpClient) {}

  getCDISummary(
    recId: number
  ): Observable<GenericResponseDto<GetCdiDetailsDto>> {
    return this._http.get<GenericResponseDto<GetCdiDetailsDto>>(
      this.cdiInvoiceBaseURL + `/GetCdiDetail?recId=` + recId
    );
  }

  getCdiDispositionDetails(
    recId: number
  ): Observable<GenericResponseDto<CdiDispositionResponseDto>> {
    return this._http.get<GenericResponseDto<CdiDispositionResponseDto>>(
      this.cdiInvoiceBaseURL + `/GetCdiDispositionDetails?recId=` + recId
    );
  }

  getCDINotes(
    recId: number
  ): Observable<GenericResponseDto<OcrInvoiceMatchingNotes[]>> {
    return this._http.get<GenericResponseDto<OcrInvoiceMatchingNotes[]>>(
      this.cdiInvoiceBaseURL + `/GetCdiNotes?recId=` + recId
    );
  }

  getCDILineDetails(
    cdiNumber: string
  ): Observable<GenericResponseDto<CDILinesDto[]>> {
    return this._http.get<GenericResponseDto<CDILinesDto[]>>(
      this.saleOrderManagementBaseURL +
        `/GetInvoicePreviewLineDetails?invoicePreviewNumber=` +
        cdiNumber
    );
  }

  getCDIListing(
    request: GenericRequestDto
  ): Observable<GenericResponseDto<CdiListingDto[]>> {
    return this._http.post<GenericResponseDto<CdiListingDto[]>>(
      this.cdiInvoiceBaseURL + `/GetCdiInvoicesPaginated`,
      request
    );
  }

  AddSalesOrderNotes(
    payload: SalesOrderNotes
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.saleOrderManagementBaseURL + "/AddSalesOrderNotes",
      payload
    );
  }

  addQuickNotes(
    payload: AddNotesRequestDto
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.cdiInvoiceBaseURL + "/AddQuickNotes",
      payload
    );
  }

  addCdiLine(
    payload: AddUpdateCdiLineDto
  ): Observable<GenericResponseDto<AddUpdateCdiLineDto>> {
    return this._http.post<GenericResponseDto<AddUpdateCdiLineDto>>(
      `${this.saleOrderManagementBaseURL}/AddCdiLine`,
      payload
    );
  }

  updatePOLine(
    payload: UpdateCdiLineDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.put<GenericResponseDto<string>>(
      `${this.saleOrderManagementBaseURL}/UpdateCdiLine`,
      payload
    );
  }

  copyCdiLines(
    payload: CopyCdiLinesRequestDto
  ): Observable<GenericResponseDto<CDILinesDto[]>> {
    return this._http.post<GenericResponseDto<CDILinesDto[]>>(
      `${this.saleOrderManagementBaseURL}/CopyPOLines`,
      payload
    );
  }

  SubmitCdiInvoiceResolution(
    payload: CdiInvoiceResolutionRequestDto
  ): Observable<GenericResponseDto<CdiInvoiceResolutionResponseDto>> {
    return this._http.post<GenericResponseDto<CdiInvoiceResolutionResponseDto>>(
      this.cdiInvoiceBaseURL + "/CdiInvoiceResolution",
      payload
    );
  }

  getCDISharePointPdf(
    documentId: string
  ): Observable<GenericResponseDto<string>> {
    return this._http.get<GenericResponseDto<string>>(
      this.d365SynchroniserBaseURL +
        `/GetCdiSharePoint?documentId=` +
        documentId
    );
  }

  getCDISummaryByPurchaseOrder(
    purchaseOrderId: string
  ): Observable<GenericResponseDto<GetCdiDetailsDto>> {
    return this._http.get<GenericResponseDto<GetCdiDetailsDto>>(
      this.cdiInvoiceBaseURL +
        `/GetCdiDetailByPoNumber?purchaseOrderId=` +
        purchaseOrderId
    );
  }
}
